import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-166">
      <div className="max-w-3xl mx-auto text-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-168">
          <p className="text-lg sm:text-xl md:text-2xl font-medium text-gray-200 leading-relaxed" data-id="element-169">
            Pianificare lezioni di informatica in modo manuale ti toglie una
            media di{' '}
            <span className="text-brand-danger font-bold" data-id="element-170">
              2-4 ore a settimana
            </span>
            . Sono{' '}
            <span className="text-brand-danger font-bold" data-id="element-171">
              più di 100 ore all'anno perse
            </span>{' '}
            — ore che potresti dedicare ai tuoi studenti, alla tua famiglia o
            semplicemente a te stesso.
          </p>
        </motion.div>
      </div>
    </section>;
}